<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { AlertDialogAction, type AlertDialogActionProps } from 'reka-ui'
import { cn } from '@/shadcn/lib/utils'
import { buttonVariants } from '@/shadcn/components/ui/button'

const props = withDefaults(defineProps<AlertDialogActionProps & { 
  class?: HTMLAttributes['class']
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link'
}>(), {
  variant: 'default'
})

const delegatedProps = reactiveOmit(props, 'class', 'variant')
</script>

<template>
  <AlertDialogAction v-bind="delegatedProps" :class="cn(buttonVariants({variant: props.variant}), props.class)">
    <slot />
  </AlertDialogAction>
</template>
